import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { CommonService } from '../../common-service';
import { ConfiguracaoCotacaoRequest } from '../../requests/compras/configuracao-cotacao.request';
import { GetConfiguracaoCotacaoResponse } from '../../responses/compras/configuracao-cotacao.response';
import { ReturnStruct } from '../../structs/return.struct';

@Injectable({
  providedIn: 'root',
})
export class ConfiguracaoCotacaoService extends CommonService {
  private readonly apiUrl: string = environment.urlApiCompras + 'ConfiguracaoCotacao';

  constructor(private httpClient: HttpClient) {
    super();
  }

  public get(): Observable<GetConfiguracaoCotacaoResponse> {
    return this.httpClient
      .get<GetConfiguracaoCotacaoResponse>(this.apiUrl, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public salvar(request: ConfiguracaoCotacaoRequest): Observable<ReturnStruct> {
    return this.httpClient
      .put<ReturnStruct>(this.apiUrl, request, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

}
